import { render, staticRenderFns } from "./index.vue?vue&type=template&id=963dd854&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=963dd854&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('963dd854')) {
      api.createRecord('963dd854', component.options)
    } else {
      api.reload('963dd854', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=963dd854&", function () {
      api.rerender('963dd854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/game/index.vue"
export default component.exports